import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Icon } from '@mgc/react-components';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import strings from '../../../strings';
import UploadConfigurationActions from '../../../actions/uploadConfiguration';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import { Grid, Col, Row } from 'react-bootstrap';
import './uploadConfiguration.scss';
import selectors from '../../../selectors';
import ExcelValidationModal from '../../Modals/ExcelValidationModal';
import ExcelValidationFailedModal from '../../Modals/ExcelValidationFailedModal';
import UiActions from '../../../actions/ui';
import { Spinner } from '@mgc/react-components';

const ACCEPT_EXTENSIONS = ['xlsm'];

class UploadConfiguration extends Component {
    static propTypes = {
        offer: PropTypes.object,
        uploadInTransit: PropTypes.bool,
        uploadProgress: PropTypes.number,
        configurationUploadError: PropTypes.object,
    };

    // constructor() {
    //     super();
    //     this.state = {
    //         dragOver: false,
    //         unknownFileType: false,
    //     };
    // }

    static mapState = (state) =>
        mapSelectors(state, {
            excelUploadErrorData:
                selectors.configurations.getExcelErrorMessageDataObj,
            clearExcelUploadErrorData:
                selectors.configurations.getExcelErrorMessageDataObj,
            excelUploadError:
                selectors.configurations.getUploadErrorResponseData,
            configurationUploadInTransit:
                selectors.configurations.getUploadInTransit,
            configurationDownloadSpinner:
            selectors.configurations.getDownloadSpinner,
            configurationUploadProgress:
                selectors.configurations.getUploadProgress,
            configurationUploadedFile: selectors.configurations.getFileUploaded,
            dragOver: selectors.configurations.dragOver,
            unknownFileType: selectors.configurations.unknownFileType,
            catchedErrorMessage: selectors.configurations.catchedErrorMessage,
            offer: selectors.offer.getSelectedOffer,
        });

    static mapDispatch = (dispatch) => ({
        uploadConfigurationSheet: (file, offerid) =>
            dispatch(UploadConfigurationActions.uploadConfigurationExcel(file, offerid)),
        setDragOver: (boolVal) =>
            dispatch(UploadConfigurationActions.setDragOver(boolVal)),
        setUnknownFileType: (boolVal) =>
            dispatch(UploadConfigurationActions.setUnknownFileType(boolVal)),
        clearExcelUploadError: () =>
            dispatch(UploadConfigurationActions.clearExcelSheetUploadError()),
        openModal: (modalName) => dispatch(UiActions.openModal(modalName)),
    });

    _onFileDrop(accepted, rejected) {
        if (rejected.length > 0 && accepted.length === 0) {
            this.props.setDragOver(false);
            this.props.setUnknownFileType(true);
            // this.setState({ unknownFileType: true, dragOver: false });
            return;
        }

        this.props.uploadConfigurationSheet(accepted[0], this.props.offer.id);
        this.props.setDragOver(false);
        this.props.setUnknownFileType(false);
        // this.setState({ unknownFileType: false, dragOver: false });
    }

    _renderContent() {
        let browseStyle = {
            fontSize: '16px',
        };
        let content = (
            <div className="pricing-pane row">
                <Col xs={9} md={6}>
                    <button
                        onClick={() => {}}
                        // onClick={() => this._handleClick(true)}
                        className="btn  btn-lg btn-block configure-button btn-primary-outline"
                    >
                        {strings.uploadNewConfiguration}
                        <br></br>
                        <span style={browseStyle}>
                            Drop file here or <u>browse</u> to upload file
                        </span>
                    </button>
                </Col>
            </div>
        );

        if (this.props.dragOver) {
            content = (
                <div className="drag-area">
                    <div className="drag-overlay text-inverse">
                        <div className="drag-indicator">
                            <Icon name="icon-file-upload2" />
                        </div>
                    </div>
                    <div className="drag-content">{content}</div>
                </div>
            );
        }

        return content;
    }

    _setDragOver(boolVal) {
        this.props.setDragOver(boolVal);
    }

    _renderDragHint() {
        let message = '';
        let className = '';

        if (this.props.unknownFileType) {
            message = strings.dragOnlyExcelFiles;
            className = 'text-danger';
        } else if (this.props.getFileUploaded) {
            message = strings.pricingUploaded;
            className = 'text-success';
        }

        return <small className={className}>{message}</small>;
    }

    _renderProgressBar() {
        const percent = this.props.configurationUploadProgress;
        let message = `${percent}% ${strings.complete}`;

        if (percent === 100) {
            message = strings.uploadedConfiguration;
        }

        return (
            <div className="text-left">
                <small>{strings.uploading}</small>
                <div className="progress progress-striped active m-b-0">
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${percent}%` }}
                    >
                        <span>{message}</span>
                    </div>
                </div>
            </div>
        );
    }

    _isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    _renderUploadError(errorObj) {
        return (
            <small className="text-danger">
                <Icon name="icon-warning" />
                &nbsp;
                {errorObj.message}
                {/* {strings.uploadError} */}
            </small>
        );
    }

    _renderDragState() {
        // if (this._isEmpty(this.props.excelUploadErrorData) === false) {
        //     return this._renderUploadError(this.props.excelUploadErrorData);
        // }

        if (this.props.configurationUploadInTransit) {
            return this._renderProgressBar();
        }

        return this._renderDragHint();
    }

    _showFailedValidationModal(event) {}

    _showSuccessValidationModal(event) {
        this.props.openModal('checkout');
    }

    _handleDownloadConfigurationButtonClick() {   
        this.props.downloadConfigurationProductList(this.props.offer.id);
    }

    _isButtonDisabled() {
        return this.props.configurationDownloadSpinner;
    }

    _renderDownloadSpinner() {
        if (this.props.configurationDownloadSpinner) {
            return (
                <div>
                    {/* <div className="spinner-text">
                    </div> */}
                    <div className="spinner-container">
                        <div className="loading-spinner"></div>
                    </div>
                </div>
            );
        }
    }



    render() {
        const fontSize = {
            fontSize: '12px',
        };
        const divRight = {
            position: 'fixed',
            right: '20px',
        };

        const floatCont = {
            border: '3px solid #fff',
            padding: '10px',
        };

        const floatChild = {
            width: '50%',
            float: 'left',
            padding: '10px',
            // border: '2px solid red',
        };

        return (
            <div className="m-b">
                <div className="text-right">
                    <div className="col-md-12 text-center text-mute">
                        {this._renderDragState()}
                    </div>
                </div>
                <div style={floatCont}>
                    {this._renderDownloadSpinner()}
                    <div style={floatChild}>
                        <div>
                            <button
                                onClick={() =>
                                    this._handleDownloadConfigurationButtonClick()
                                }
                                disabled={this._isButtonDisabled()}
                                className="btn btn-lg btn-block configure-button btn-primary-outline"
                            >
                                {strings.downloadConfigurationProductList}
                                <br></br>
                                <span>&nbsp;</span>
                            </button>
                        </div>
                    </div>

                    <div style={floatChild}>
                        <div>
                            <Dropzone
                                disableClick={false}
                                style={{ position: 'absolute', width: '65%' }}
                                accept={ACCEPT_EXTENSIONS.map(
                                    (e) => `.${e}`
                                ).join(',')}
                                onDrop={(a, r) => this._onFileDrop(a, r)}
                                onDragEnter={() => this._setDragOver(true)}
                                onDragLeave={() => this._setDragOver(false)}
                            >
                                {this._renderContent()}
                            </Dropzone>
                        </div>
                    </div>
                </div>
                <ExcelValidationModal
                    configurationSheetUploadResponse={
                        this.props.configurationSheetUploadResponse
                    }
                />
                <ExcelValidationFailedModal />
            </div>
        );
    }
}

export default attach(UploadConfiguration);



// WEBPACK FOOTER //
// ./app/components/OrderForm/UploadConfiguration/index.jsx